import { AsyncSingleSelectField, CharField, SingleSelectField, TextAreaField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import { Facsimile } from "../../types"
import { useState } from "react"
import { useEdizione, useEdizioneCreate, useEdizioneLazy, useEdizioniLazy, useEdizioniList } from "../../hooks/edizioni"
import EdizioneModal from "../Edizioni/EdizioneModal"
import useModalTrigger from "magik-react-hooks/useModalTrigger"
import { WysiwygField } from "../../components/WysiwygField"

export default function FacsimileForm({ col, showEdizione = false }: { col?: number; showEdizione?: boolean }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<Facsimile>()

  const fetchEdizione = useEdizioneLazy()
  const fetchEdizioni = useEdizioniLazy()

  const [modalStateCreateEdizione, modalActionsCreateEdizione] = useModalTrigger()

  const createEdizione = useEdizioneCreate()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      {showEdizione && (
        <AsyncSingleSelectField
          label="Edizione"
          placeholder="Seleziona un'edizione"
          layout="horizontal"
          onChange={(value) => {
            setFieldValue("edizione", value)
          }}
          clearable
          value={values.edizione}
          loadOptions={(inputValue: string) => {
            return fetchEdizioni({ search: inputValue }).then((edizioni) => {
              return edizioni.results?.map((edizione) => ({
                label: edizione.opera_data?.titolo + " - " + edizione.titolo_completo,
                value: edizione.id,
              }))
            })
          }}
          loadInitialValue={(id: number) =>
            fetchEdizione(id).then((edizione) => {
              return { label: edizione.opera_data?.titolo + " - " + edizione.titolo_completo, value: edizione.id }
            })
          }
          required
          isValid={submitCount > 0 ? !getIn(errors, "edizione") : undefined}
          errorMessage={getIn(errors, "edizione")}
        >
          <SingleSelectField.Add
            onClick={() => {
              modalActionsCreateEdizione.open()
            }}
          />
        </AsyncSingleSelectField>
      )}

      <WysiwygField
        label="Titolo"
        layout="horizontal"
        value={values.titolo}
        onChange={(value) => {
          setFieldValue("titolo", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "titolo") : undefined}
        errorMessage={getIn(errors, "titolo")}
        required
      />
      {modalStateCreateEdizione.isOpen && (
        <EdizioneModal
          show={modalStateCreateEdizione.isOpen}
          onClose={modalActionsCreateEdizione.close}
          showOpera={showEdizione}
          save={(values) => {
            return createEdizione.mutateAsync(values).then((edizione) => {
              setFieldValue("edizione", edizione.id)
              modalActionsCreateEdizione.close()
            })
          }}
          title="Crea edizione"
        />
      )}
    </Col>
  )
}
